const PrivacyPage = () => {
  return (
    <div className="pt-20 min-h-screen" data-testid="privacy-page">
      {/* Header */}
      <section className="py-16 border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <span className="text-sm uppercase tracking-widest text-[#D4AF37]">Legal</span>
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight mt-4 font-serif">
            Privacy Policy
          </h1>
          <p className="text-muted-foreground mt-4">
            Gold Spot Tax
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-12 lg:px-24">
          <div className="space-y-8">
            
            <div>
              <p className="text-xl text-white font-semibold mb-4">We respect your privacy.</p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-4">We collect:</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Name, phone number, email, and tax-related information</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-4">We use your information to:</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>Provide tax services</li>
                <li>Communicate via phone, SMS, or email</li>
              </ul>
            </div>

            <div>
              <p className="text-muted-foreground leading-relaxed">
                We <strong className="text-white">DO NOT</strong> sell or share your information with third parties except as required by law.
              </p>
            </div>

            <div className="bg-[#0A0A0A] border border-[#D4AF37]/30 p-6">
              <h2 className="text-xl font-semibold text-[#D4AF37] mb-4">SMS Consent:</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 ml-4">
                <li>By providing your phone number, you agree to receive text messages</li>
                <li>Message and data rates may apply</li>
                <li>You can opt out anytime by replying STOP</li>
              </ul>
            </div>

            <div className="bg-[#0A0A0A] border border-white/5 p-6">
              <h2 className="text-xl font-semibold text-white mb-4">Contact us:</h2>
              <p className="text-muted-foreground flex items-center gap-2">
                <span>📞</span> 202-704-2459
              </p>
              <p className="text-muted-foreground flex items-center gap-2 mt-2">
                <span>📍</span> 738 Longfellow St NW Unit 107, Washington, DC
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
